<div style="position:relative;height: 100%;">
<div style="text-align: center;position: absolute;top: 40%;left: 50%;transform: translate(-50%, -50%);">
  <img src="../../assets/images/page-not-found.png">
  <p style="font-size: 4.5rem">404 Error</p>
  <p>Page not found</p>
</div>
</div>

